module.exports = __webpack_public_path__ + "static/media/PF-001Skimmer.86a990c1.png";